module.exports = __webpack_public_path__ + "static/media/img-ccus-explain_not_owner.83a7ae2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ccus-explain_not_owner.png
// module id = 13606
// module chunks = 0